export const CHANGE_CARD_TIER = "CHANGE_CARD_TIER";
export const FETCH_CUSTOMER_CARDS_STARTED = "FETCH_CUSTOMER_CARDS_STARTED";
export const FETCH_CUSTOMER_CARDS_SUCCEEDED = "FETCH_CUSTOMER_CARDS_SUCCEEDED";
export const CREATE_CARD_SUCCEEDED = "CREATE_CARD_SUCCEEDED";
export const CREATE_CARD_FAILED = "CREATE_CARD_FAILED";
export const FETCH_CUSTOMER_CARDS_FAILED = "FETCH_CUSTOMER_CARDS_FAILED";
export const CHANGE_CARD_NEW_REQUEST = "CHANGE_CARD_NEW_REQUEST";
export const BLOCK_UNBLOCK_CARD_STARTED = "BLOCK_UNBLOCK_CARD_STARTED";
export const BLOCK_UNBLOCK_CARD_SUCCEEDED = "BLOCK_UNBLOCK_CARD_SUCCEEDED";
export const BLOCK_UNBLOCK_CARD_FAILED = "BLOCK_UNBLOCK_CARD_FAILED";
export const RETRY = "RETRY";
export const SET_HAS_CARD_RESPONDED = "SET_HAS_CARD_RESPONDED";
export const SET_RETRY_MODAL = "SET_RETRY_MODAL";
export const SET_CARD_BLOCK_MODAL_SUCCESS = "SET_CARD_BLOCK_MODAL_SUCCESS";
export const ENABLE_OR_DISABLE_CHANNEL_STARTED = "ENABLE_OR_DISABLE_CHANNEL_STARTED";
export const ENABLE_OR_DISABLE_CHANNEL_SUCCEEDED = "ENABLE_OR_DISABLE_CHANNEL_SUCCEEDED";
export const ENABLE_OR_DISABLE_CHANNEL_FAILED = "ENABLE_OR_DISABLE_CHANNEL_FAILED";
export const VALIDATE_PIN_STARTED = "VALIDATE_PIN_STARTED";
export const VALIDATE_PIN_SUCCEEDED = "VALIDATE_PIN_SUCCEEDED";
export const VALIDATE_PIN_FAILED = "VALIDATE_PIN_FAILED";
export const GET_DEFAULT_PIN_STARTED = "GET_DEFAULT_PIN_STARTED";
export const GET_DEFAULT_PIN_SUCCEEDED = "GET_DEFAULT_PIN_SUCCEEDED";
export const GET_DEFAULT_PIN_FAILED = "GET_DEFAULT_PIN_FAILED";
export const GET_LINKED_CARD_DATA = "GET_LINKED_CARD_DATA";
export const CHANGE_WEB_STATUS = "CHANGE_WEB_STATUS";
export const CHANGE_CUSTOMER_DEBIT_CARDS = "CHANGE_CUSTOMER_DEBIT_CARDS";
export const RESET_SHOW_PIN = "RESET_SHOW_PIN";
export const SHOW_BLOCK_CARD_MODAL = "SHOW_BLOCK_CARD_MODAL"
export const SET_CARD_BLOCK_STATUS = "SET_CARD_BLOCK_STATUS"
export const GET_DELIVERY_CHARGES_STARTED = "GET_DELIVERY_CHARGES_STARTED";
export const GET_DELIVERY_CHARGES_SUCCESS = "GET_DELIVERY_CHARGES_SUCCESS";
export const GET_DELIVERY_CHARGES_FAILED = "GET_DELIVERY_CHARGES_FAILED";
export const SET_ACTIVE_SELECTION = "SET_ACTIVE_SELECTION";
export const SET_ACTIVE_SELECTION_INDEX = "SET_ACTIVE_SELECTION_INDEX";